export function getWorkerToWorkplaceVariantName(isAffiliateProgramEnabled: boolean) {
  return isAffiliateProgramEnabled ? "affiliate-program" : "referrals";
}
